// src/utils/dateHelpers.js
// Formateo de fechas de reclamos, consolidado desde las copias duplicadas
// que existían en ClaimsList.jsx, ClaimsDirectory.jsx, Dashboard.jsx e
// invoiceGenerator.js. El formato de almacenamiento es siempre MM/DD/YYYY;
// estos helpers solo convierten para mostrar (MM/DD/YYYY) o para inputs
// type="date" (YYYY-MM-DD).

// MM/DD/YYYY, YYYY-MM-DD o ISO -> MM/DD/YYYY para mostrar
export const formatDateToMMDDYYYY = (dateString) => {
  if (!dateString) return 'N/A';

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  }

  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  return dateString;
};

// MM/DD/YYYY, YYYY-MM-DD o ISO -> YYYY-MM-DD (para <input type="date">)
export const formatDateToYYYYMMDD = (dateString) => {
  if (!dateString) return '';

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    const [month, day, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }

  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  return dateString;
};

// Convierte cualquier formato soportado a un timestamp comparable, para ordenar.
// Devuelve 0 para fechas ausentes o inválidas (nunca un valor real en esta
// app), así el que llama puede detectarlas y mandarlas al final del orden
// en vez de que queden mezcladas en cualquier lugar.
export const parseDateForSort = (dateString) => {
  if (!dateString) return 0;

  if (typeof dateString === 'string') {
    // MM/DD/YYYY (o MM/DD/YY) — el mes siempre va primero, como se guarda
    // en toda la app.
    const match = dateString.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
    if (match) {
      const month = Number(match[1]);
      const day = Number(match[2]);
      let year = Number(match[3]);
      if (year < 100) year += 2000;

      if (month < 1 || month > 12 || day < 1 || day > 31) return 0;

      const date = new Date(year, month - 1, day);
      // Date normaliza fechas imposibles (ej. 31 de abril -> 1 de mayo) en
      // vez de fallar — si el mes resultante no coincide, era inválida.
      if (date.getMonth() !== month - 1) return 0;
      return date.getTime();
    }
  }

  const date = new Date(dateString);
  return isNaN(date.getTime()) ? 0 : date.getTime();
};

// Fecha de hoy 'YYYY-MM-DD' en la hora LOCAL del usuario (no UTC): con
// toISOString(), en Florida después de las ~8 pm salía el día siguiente.
export const localTodayISO = (date = new Date()) => {
  const pad = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
